import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { extractAndStoreMobileJWTToken } from '@core/utils/AuthUtils';
import MobileLoading from './components/MobileLoading';

// Extract and store JWT token from URL parameters
extractAndStoreMobileJWTToken();

const App = React.lazy(() => import('./App'));

const container = document.getElementById('root');
const app = React.createElement(
  Suspense,
  {
    fallback: React.createElement(MobileLoading),
  },
  React.createElement(App),
);

if (container) {
  ReactDOM.render(app, container);
}
